import React from "react";
import { Box, Dialog, IconButton, Typography } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import styles from "./zeroTrustPolicies.module.scss";

const GenericStepperDialog = ({
  open,
  title,
  subtitle,
  steps,
  activeStep,
  onClose,
  children,
  footer,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      PaperProps={{ className: styles.stepperDialog }}
    >
      <Box className={styles.stepperDialogHeader}>
        <Box>
          <Typography className={styles.stepperDialogTitle}>{title}</Typography>
          {subtitle ? (
            <Typography className={styles.stepperDialogSubtitle}>
              {subtitle}
            </Typography>
          ) : null}
        </Box>
        <IconButton onClick={onClose} className={styles.stepperDialogClose}>
          <CloseRoundedIcon />
        </IconButton>
      </Box>

      <Box className={styles.stepperRow}>
        {steps.map((step, index) => {
          const isActive = index === activeStep;
          const isDone = index < activeStep;
          const Icon = step.icon;
          return (
            <React.Fragment key={step.label}>
              <Box
                className={`${styles.stepperStep} ${
                  isActive ? styles.stepperStepActive : ""
                } ${isDone ? styles.stepperStepDone : ""}`}
              >
                <Box className={styles.stepperIconWrap}>
                  <Icon fontSize="small" />
                </Box>
                <Typography className={styles.stepperLabel}>
                  {step.label}
                </Typography>
              </Box>
              {index < steps.length - 1 ? (
                <span
                  className={`${styles.stepperLine} ${
                    isDone ? styles.stepperLineActive : ""
                  }`}
                />
              ) : null}
            </React.Fragment>
          );
        })}
      </Box>

      <Box className={styles.stepperDialogBody}>{children}</Box>

      <Box className={styles.stepperDialogFooter}>{footer}</Box>
    </Dialog>
  );
};

export default GenericStepperDialog;
